:host {
  --aha-page-thumbnail--padding: var(--spacer-3);
  --aha-page-thumbnail--margin: var(--spacer-3);
  width: 100%;
  padding: var(--aha-page-thumbnail--padding);
  margin: var(--aha-page-thumbnail--margin);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: var(--theme-secondary-background);
  border: 1px solid transparent;
  border-radius: 4px;
}

:host(:hover) {
  border: 1px solid var(--theme-primary-border);
  box-shadow: 0 0 8px 0px rgba(0, 0, 0, 0.08);
}

:host(:hover) #page-thumbnail--title {
  color: var(--theme-link-text);
}

:host([selected]) {
  background-color: var(--theme-list-item-active-background);
}

a {
  text-decoration: none;
}

#content {
  height: 100%;
  display: flex;
  flex-direction: column;
}
#image-wrapper {
  display: inherit;
  flex-direction: inherit;
  justify-content: center;
  flex: 1 1;
  margin-bottom: var(--spacer-2);
  background-color: var(--theme-primary-background);
}
img {
  display: block;
  width: 100%;
  min-height: var(--aha-image-tile--height, auto);
  object-fit: contain;
  object-position: center top;
}

#page-thumbnail--title {
  display: -webkit-box;
  margin-bottom: var(--spacer-1);
  color: var(--theme-primary-text);
  font-weight: 600;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;

  span {
    height: 12px;
    margin-right: var(--spacer-1);
  }
}

#page-thumbnail--last-accessed {
  color: var(--theme-secondary-text);
}

#page-thumbnail--share-link {
  position: absolute;
  top: 10px;
  right: 10px;
  background: var(--aha-blue-100);
  border: 1px solid var(--aha-blue-200);
  color: var(--aha-blue-400);
  border-radius: 50%;
  width: 15px;
  height: 15px;
  font-size: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

slot[name='file-type-icon']::slotted(span) {
  color: var(--theme-primary-text);
  font-size: inherit;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
